export type FiltersMessages = {
  filterByLabel: string;
  filterButton: string;
  allOption: string;
  search: string;
  valueLabel: string;
  clearButton: string;
};

export const FILTER_MESSAGES: FiltersMessages = {
  filterByLabel: "Filtrar por",
  allOption: "Todos",
  valueLabel: "Valor",
  search: "Pesquisa",
  filterButton: "Filtrar",
  clearButton: "Limpar filtros",
};
